//
//
//
//
//
//
//
//
//

export default {
  name: 'App',
  data(){
    return{
      scrollTop:0
    }
  },
  methods: {
    //  获取系统默认配置信息
    getDefaultSystemParam() {
      this.$get('api/config-para/search-with-list?_allow_anonymous=true', {mainCode: 'defaultManage'}).then((data) => {
        let defaultParam = {};
        if (data.configParaDts) {
          data.configParaDts.forEach((item) => {
            defaultParam[item.typeCode] = item.paraValue1;
          });
        }
        this.$store.dispatch('commitChangeSystemParam', defaultParam);
      })
    },

    //  获取是浏览器内部还是app内部打开的
    getDevice() {
      if (this.$route.query.device === 'android') {
        this.$store.dispatch('commitChangeDevice', 'android');
        try {
          if (MyWebView.getNativeParamValue('token')) {
            this.$store.dispatch('commitChangeToken', MyWebView.getNativeParamValue('token'));
          }
        } catch (e) {
          this.$store.dispatch('commitChangeToken', this.$route.query.token);
        }
      } else if (this.$route.query.device === 'ios') {
        this.$store.dispatch('commitChangeDevice', 'ios');
        if (this.$route.query.token) {
          this.$store.dispatch('commitChangeToken', "Bearer " + this.$route.query.token);
        }
      } else {
        this.$store.dispatch('commitChangeDevice', 'wap');
      }
    },
    //获取 存入 版本信息
    getVersion(){
      let oldVersion=localStorage.getItem('version');
      let newVersion;
      this.$get('api/dict-tables/version').then(data=>{
        newVersion=data.version;
        if(oldVersion){
        //  比较
          if( oldVersion!=newVersion){
            localStorage.setItem('version',data.version);
            //移除 主表信息
            this.$get('api/dict-tables/find-all').then(ditcList=>{
              if(ditcList && ditcList.length){
                ditcList.forEach(list=>{
                  if(list && list.dicts && list.dicts.length){
                    list.dicts.forEach(dict=>{
                      localStorage.removeItem(dict.code)
                    })
                  }

                })
              }

            })
          }
        }else {
          localStorage.setItem('version',data.version);
        }
      })
    },

  //免登录处理，从url上获取token
    avoidLogin(){
      if(this.$route.query.userAuthor){
        let token = this.$route.query.userAuthor;
        localStorage.setItem('_token', "Bearer " + token);
      }
    }
  },
  created() {
    this.avoidLogin();
    this.getDevice();
    // this.getVersion();
    this.getDefaultSystemParam();
    this.$get('api/system-config/basic?_allow_anonymous=true').then((data) => {
      this.$store.dispatch('commitChangeSystemConfig', data);
      window.document.getElementById("appTitle").innerText = data.name;
    });
    //解决键盘对屏幕高度的影响
    // let isiPhone = navigator.userAgent.toLocaleLowerCase().match(/iPhone/i);
    // document.body.addEventListener('focusin', () => {
    //   // 软键盘弹出的事件处理
    //   if(isiPhone){
    //     this.scrollTop = document.documentElement.scrollTop;
    //   }
    // });
    // document.body.addEventListener('focusout', () => {
    //   // 软键盘收起的事件处理
    //   setTimeout(() => {
    //     if(isiPhone){
    //       if(this.scrollTop){
    //         window.scroll(0, this.scrollTop);
    //       }else{
    //         window.scroll(0, 0);
    //       }
    //     }
    //   },200);
    // });

    /**
     * 监听动态表单业务跳转
     * */
    window.addEventListener('message',(event) => {
      if(event.data.bizType){
        //此处执行事件
        switch (event.data.bizType){
          case 'supplier':
            if(event.data.id){
              this.$router.push(`/sup-view/${event.data.id}`);
            }
          case 'sourceComparePrice':
            if(event.data.id){
              this.$router.push(`/parity-detail/${event.data.id}`);
            }
            break;
          default:
            break;
        }
      }
    });
    /**
     * 监听区分司机
     * */
    if(localStorage.getItem('_token') && this.$route.path !== '/driver/login' && this.$route.path !== '/user/login'){
      this.$get('api/user/current').then((res) => {
        let driverBol = false;
        if(res.roles){
          res.roles.forEach((item) => {
            if(item.name === 'ROLE_DRIVER_SUP'){
              driverBol = true;
            }
          })
        }
        if(this.$route.meta && this.$route.meta.driver && !driverBol){
          this.$vux.toast.text('当前登录人员非司机，请通过SRM平台入口访问系统');
        }
        if(!(this.$route.meta && this.$route.meta.driver) && driverBol){
          this.$vux.toast.text('当前登录人员为司机，请通过司机端入口访问系统');
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.vue